import Button from "../../custom/button/button";
import certificate from "../../assets/certificate.svg";
import styles from "./styles.module.scss";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  downloadAppreciationLetter,
  getAppreciationLetter,
} from "../../requests";
import { useAtomValue } from "jotai";
import { userProfile } from "../../state";
import { App, Empty, Spin } from "antd";
import { AxiosError } from "axios";
import classNames from "classnames";
import { useState } from "react";
import { errorMessage } from "../../utils/errorMessage";

const AppreciationLetter = () => {
  const { notification } = App.useApp();
  const [currentId, setCurrentId] = useState<number>(0);
  const profile = useAtomValue(userProfile);

  const downloadLetterMutation = useMutation({
    mutationFn: downloadAppreciationLetter,
  });
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["get-appreciation-letter"],
    queryFn: () => getAppreciationLetter(profile?.MembershipNo),
  });
  const letter = data?.Data as AppreciationLetter[];

  const handleDownload = async (id: number) => {
    try {
      await downloadLetterMutation.mutateAsync(id, {
        onSuccess: (data) => {
          const url = window.URL.createObjectURL(data);
          const a = document.createElement("a");
          a.href = url;
          a.download = "AppreciationLetter.pdf";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
      });
    } catch (error: any) {
      let response = await error?.response?.data.text();
      const actualObj = JSON.parse(response);
      notification.error({
        message: "Error",
        description: actualObj?.Message || errorMessage(error),
      });
    }
  };

  if (isLoading) return <Spin />;
  if (isError) return <div>{(error as AxiosError)?.message}</div>;

  return (
    <div>
      <section className={classNames("spaceBetween")}>
        {letter?.length > 0 && <h3>Appreciation Letter</h3>}
      </section>

      {letter?.length > 0 ? (
        <section className={styles.documentContainer}>
          {letter.map((item) => (
            <div className={styles.document} key={item.Id}>
              <div className={styles.spaceBetween}>
                <img src={certificate} alt="certificate" />
                <Button
                  isLoading={
                    item.Id === currentId
                      ? downloadLetterMutation.isPending
                      : false
                  }
                  disabled={
                    item.Id === currentId
                      ? downloadLetterMutation.isPending
                      : false
                  }
                  onClick={() => {
                    setCurrentId(item.Id);
                    handleDownload(item.Id);
                  }}
                  text="Download"
                />
              </div>
              <label>APPRECIATION LETTER</label>
              {/* <h4>{item.CertTitl}</h4> */}
              <p>Your appreciation letter</p>
              <div className={styles.documentDetails}>
                {item.Id}
                <span className={styles.bulletSeparator}></span>
                <span>0 points earned</span>
              </div>
            </div>
          ))}
        </section>
      ) : (
        <Empty
          description={
            <p
              style={{
                justifySelf: "center",
                alignSelf: "center",
                fontSize: 24,
                fontWeight: 600,
                color: "#f00d0d",
              }}
            >
              No appreciation letter available
            </p>
          }
        />
      )}
    </div>
  );
};

export default AppreciationLetter;
